function round2 (n) {
  return Math.round(n * 100) / 100
}

export function priceExIncFromSell (sellPrice) {
  const ex = parseFloat(sellPrice)
  if (!Number.isFinite(ex) || ex < 0) {
    return { priceExGst: '0.00', priceIncGst: '0.00' }
  }
  const inc = round2(ex * 1.1)
  return {
    priceExGst: ex.toFixed(2),
    priceIncGst: inc.toFixed(2)
  }
}

export function getDifficultyLabel (location, multipliers) {
  const raw = location != null ? location : 1
  const list = Array.isArray(multipliers) ? multipliers : []
  const match = list.find(m => m && (m.id == raw || parseFloat(m.id) === parseFloat(raw)))
  if (match && match.name != null) return String(match.name)
  const n = parseFloat(raw)
  return Number.isFinite(n) ? 'x' + n : String(raw)
}

/**
 * Build an immutable compare snapshot from the live task modal task object.
 */
export function buildCompareSnapshot (task, sellPrice, difficultyLabel) {
  const prices = priceExIncFromSell(sellPrice)
  const snapshot = JSON.parse(JSON.stringify(task))
  snapshot.task_id = snapshot.task_id != null ? snapshot.task_id : snapshot.id
  snapshot.sell_price = sellPrice != null ? String(sellPrice) : snapshot.sell_price
  snapshot.priceExGst = prices.priceExGst
  snapshot.priceIncGst = prices.priceIncGst
  snapshot.difficultyLabel = difficultyLabel || getDifficultyLabel(snapshot.location, [])
  snapshot.addedToQuote = false
  return snapshot
}
